import request from '@/utils/request'

export function getPublicKey() {
  return request({
    url: `/system/publicKey`,
    method: 'get',
  })
}